import { Stack, Typography } from '../../ui/core';
import { useFormatters } from '../../hooks';

/**
 * Shared presentation for a single waypoint (pick-up/drop-off): a label, the
 * waypoint's name/address (or an em dash when absent), and an optional
 * timestamp.
 *
 * `stacked` puts the label above the value instead of beside it — a full
 * address and a timestamp do not fit on one line in a 420px panel, and the
 * wrapped row reads as a ragged block with the label stranded on top.
 */
export const WaypointSummary = ({ label, waypoint, time, stacked = false }) => {
  const f = useFormatters();

  if (stacked) {
    return (
      <Stack spacing="2px">
        <Typography color="text.secondary" variant="caption">
          {label}
        </Typography>
        <Typography variant="body2">{waypoint ? waypoint.name || waypoint.address : '—'}</Typography>
        {time && (
          <Typography color="text.secondary" variant="caption">
            {f.date.toLocaleString(time, f.date.DateFormats.DATETIME_MED)}
          </Typography>
        )}
      </Stack>
    );
  }

  return (
    <Stack direction="row" spacing="8px">
      <Typography color="text.secondary" variant="body2" sx={{ whiteSpace: 'nowrap' }}>
        {label}
      </Typography>
      <Typography>
        {waypoint ? waypoint.name || waypoint.address : '—'}
        {time && ` · ${f.date.toLocaleString(time, f.date.DateFormats.DATETIME_MED)}`}
      </Typography>
    </Stack>
  );
};

export default WaypointSummary;
